import React, { useRef } from 'react'
import ImageSlider from '../../../FinalOutput/Components/Slider-prewedding/ImageSlider';
import PreWeddingVideo from '../../../FinalOutput/Components/Slider-prewedding/PreWeddingVideo';
import './sliderpre.css'

import { useGSAP } from '@gsap/react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const Sliderpre = ({details}) => {
  const sectionRef = useRef(null);
  const frameRef = useRef(null);

    const images = details?.footerImages || [];
  const preWeddingLink = details?.preWeddingLink?.trim();

  const hasImages = images.length > 0;
  const hasPreWedding = !!preWeddingLink;

   useGSAP(() => {

    // Frame is optional
    if (!frameRef.current) return;

    gsap.fromTo(
      frameRef.current,
      {
        opacity: 0,
        y: -35,
        scale: 0.985,
      },
      {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 0.9,
        ease: "power2.out",

        scrollTrigger: {
          trigger: frameRef.current,
          start: "top 70%",
          once: true,
        },
      }
    );

  }, {
    scope: sectionRef,
  });

    if (!hasImages && !hasPreWedding) {
    return null;
  }

  return (
    <section
     ref={sectionRef}
     className={`t3-slider-section
        ${details?.theme || ''}
        ${hasPreWedding ? "has-prewedding" : ""}`}>

        <img  ref={frameRef} src="/theme-3-slider-frame.webp" alt="slider-frame" className='t3-slider-frame' />

         <div className="t3-slider-content">
             {hasImages &&  <ImageSlider  images={images}  /> }
             {preWeddingLink &&  <PreWeddingVideo   link={preWeddingLink}  /> }
         </div>


    </section>
  )
}

export default Sliderpre